import { greens, reds } from '../../base/colors';

const icons = {
  wishlist: reds.red400,
  checkIconColor: greens.green500,
};

export default icons;
